import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core'
import { useConfig } from 'hooks/useConfig'
import axios from 'axios'

const BOLDelete = ({ open, handleClose, bolData, getBOLs, sqlParams, currentTerminal }) => {
  const { config } = useConfig()
  const [error, setError] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  if (!bolData) return null

  const { bolId, source_fulfillment_id, truck_load_id } = bolData

  const handleDelete = async () => {
    setSubmitting(true)
    try {
      await axios.post(`${config.LOGITRAC_API_URL}api/bols/delete`, { bolId, currentTerminal })
      handleClose()
      getBOLs({ ...sqlParams, page_number: 0, currentTerminal })
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to delete BOL')
      setSubmitting(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-bol-title"
      aria-describedby="delete-bol-description"
    >
      <DialogTitle id="delete-bol-title">{`You Are Attempting to Delete BOL #${bolId}`}</DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-bol-description">
          This will permanently remove this in-process BOL. Use this only for BOLs created in error. THIS CANNOT BE
          UNDONE. ARE YOU SURE YOU WISH TO DELETE THIS BOL?
        </DialogContentText>
        {source_fulfillment_id && (
          <DialogContentText style={{ color: '#ff9800' }}>
            This BOL originated from SandDrive (Truck Load ID: {truck_load_id}). Deleting it here will not notify
            SandDrive — make sure this load has already been cancelled on the SandDrive side.
          </DialogContentText>
        )}
        {error && <DialogContentText style={{ color: '#ef5350' }}>{error}</DialogContentText>}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          style={{ backgroundColor: 'rgb(67, 160, 71)', color: 'white', padding: '9px 20px', marginLeft: '30px' }}
        >
          NO! Don't Change Anything!
        </Button>
        <Button
          onClick={handleDelete}
          disabled={submitting}
          style={{ backgroundColor: '#ef5350', color: 'white', padding: '9px 20px', marginLeft: '30px' }}
          autoFocus
        >
          Delete BOL
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default BOLDelete
